import { saveSamlProviderSetting } from './saveSamlProviderSetting';
import { updateBillingCompany } from './updateBillingCompany';

// actionName と function のマッピング
export const tenantCallMap = {
  saveSamlProviderSetting: saveSamlProviderSetting,
  updateBillingCompany: updateBillingCompany,
};
